/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".home[_ngcontent-%COMP%]{position:relative;height:100vh;background:linear-gradient(111.24deg,#4fabfc 16.63%,#2f94ed 89.25%)}.home[_ngcontent-%COMP%]   .background-big[_ngcontent-%COMP%]{position:absolute;top:10%;height:90%}.home[_ngcontent-%COMP%]   .background-small[_ngcontent-%COMP%]{position:absolute;top:50%;left:25%;height:50%;width:75%}@media (min-width:992px){.home[_ngcontent-%COMP%]   .background-big[_ngcontent-%COMP%]{width:60%}}@media (max-width:992px){.home[_ngcontent-%COMP%]   .background-big[_ngcontent-%COMP%]{width:90%}}"];
export { styles as styles };
